/*
const myShape = new WedgeShape({
  x: 50,
  y: 50,
  stroke: engraveColor,
  strokeWidth: 5,
  angle: 22.5,
  radius: 200  
});
//console.log("myShape", myShape);
layer.add(myShape);
selectNode(myShape);
layer.draw();
*/
class WedgeShape extends Konva.Path {
  constructor(config) {
    super(config);
    
    this.className = 'Wedge';
    this.attrs.type = "shape";

    //this.setData( generateTeardropSvgTextPath(400, 400, this.attrs.radius) );

    if (this.attrs.radius == undefined) {
      this.setRadius(200);
    }

    if (this.attrs.angle == undefined) {
      this.setHeight(22.5);
    }

    this.updatePath();
    
    this.setDraggable(true);
  }

  _radius() {
    Konva.TextPath.prototype.radius.call(this);
  }

  _angle() {
    Konva.TextPath.prototype.angle.call(this);
  }
}

WedgeShape.prototype.getRadius = function () {
  return this.attrs.radius;
};

WedgeShape.prototype.setRadius = function (radius) {
  this.attrs.radius = parseInt(radius);
  this.updatePath();
};

WedgeShape.prototype.getAngle = function () {
  return this.attrs.angle;
};

WedgeShape.prototype.setAngle = function (angle) {
  this.attrs.angle = angle;
  this.updatePath();
};

WedgeShape.prototype.updatePath = function () {
  this.setData(this.generateSvgPath(0, 0, this.getRadius(), 0, this.getAngle()));
};

WedgeShape.prototype.generateSvgPath = function(cx, cy, r, startAngle, endAngle) {
    // Convert angles to radians
    const startRad = (Math.PI / 180) * startAngle;
    const endRad = (Math.PI / 180) * endAngle;
    
    // Calculate start and end points
    const x1 = cx + r * Math.cos(startRad);
    const y1 = cy + r * Math.sin(startRad);
    const x2 = cx + r * Math.cos(endRad);
    const y2 = cy + r * Math.sin(endRad);
    
    // Determine if arc sweeps more than 180 degrees
    const largeArc = (endAngle - startAngle) > 180 ? 1 : 0;
    
    // Create the path string
    return `M${cx},${cy} L${x1},${y1} A${r},${r} 0 ${largeArc},1 ${x2},${y2} Z`;
}
